import axios from "axios";

export default function getDispatchInstructionDetail(uuid) {
  return new Promise((resolve, reject) => {
    axios
      .get(`/distributor/admin/api/v1/dispatch-instruction/${uuid}/detail`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
